import { get } from 'lodash';
import { LOCAL_STORAGE_SHOW_MINIMIZABLE_MODAL_TOOLTIP } from '../constants/local-storage';

export const getLocalStorage = state => state.localStorage;

export const getIsMinimizableModalTooltipVisible = state =>
  get(getLocalStorage(state), LOCAL_STORAGE_SHOW_MINIMIZABLE_MODAL_TOOLTIP, true);
